module.exports = __webpack_public_path__ + "static/images/logo_BIFP_150.2242100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_BIFP_150.png
// module id = 4quz
// module chunks = 1